import { render, staticRenderFns } from "./myRepair.vue?vue&type=template&id=2674b870&scoped=true&"
import script from "./myRepair.vue?vue&type=script&lang=js&"
export * from "./myRepair.vue?vue&type=script&lang=js&"
import style0 from "./myRepair.vue?vue&type=style&index=0&id=2674b870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2674b870",
  null
  
)

export default component.exports